import { h, Component } from "preact";
import { Text } from "preact-i18n";
import IconBar from "./iconBar.js";

import { Link } from "preact-router/match";
import { route } from "preact-router";

import store from "../store";

class Plans extends Component {
  state = {
    persentage: [0, 0, 0]
  };
  componentDidMount() {
    window.addEventListener("scroll", () => this.handleScroll());
  }
  handleScroll() {
    if (!this.container) return;
    if (this.container.getBoundingClientRect().y < 300) {
      this.setState({
        persentage: [10, 50, 100]
      });
    }
  }
  render(props) {
    return (
      <div {...props}>
        <div class="container" ref={el => (this.container = el)}>
          <h2 class="section-header">
            <span>
              <Text id="plans.header.item" />
            </span>{" "}
            <Text id="plans.header.item2" />
          </h2>
          <p>
            <Text id="plans.desc.item" />
            <br /> <Text id="plans.desc.item2" />{" "}
            <Link href={store.prefix + "/availability"}>
              <Text id="plans.desc.link" />
            </Link>
            .
          </p>
          <ul class="plans clearfix">
            <li>
              <div class="inner">
                <h3>
                  <Text id="plans.items.first.title" />
                </h3>
                <IconBar
                  color="#69788d"
                  number="200"
                  percent={this.state.persentage[0]}
                />
                <ul>
                  <li>
                    <Text id="plans.items.first.advantage.item" />
                  </li>
                  <li>
                    <Text id="plans.items.first.advantage.item1" />
                  </li>
                  <li class="highlight">
                    <Text id="plans.items.first.advantage.item2" />
                  </li>
                  <li>
                    <Text id="plans.items.first.advantage.item3" />
                  </li>
                </ul>
                <div class="price">
                  <span class="value">€29</span>{" "}
                  <span class="period">
                    / <Text id="cart.month.full" />
                  </span>
                </div>
                <div class="term">
                  <Text id="plans.items.note" />{" "}
                  <div>
                    <Text id="plans.items.first.noteMonth" />{" "}
                    <Text id="cart.months.full" />
                  </div>
                </div>
              </div>
              <a
                onClick={() => {
                  store.setDesiredService(1);
                  route(store.prefix + "/availability");
                }}
                href="javascript:"
                class="button"
              >
                <Text id="plans.items.btn" />
              </a>
            </li>
            <li>
              <div class="inner">
                <h3>
                  <Text id="plans.items.second.title" />
                </h3>
                <IconBar
                  color="#1dba16"
                  number="500"
                  percent={this.state.persentage[1]}
                />
                <ul>
                  <li>
                    <Text id="plans.items.second.advantage.item" />
                  </li>
                  <li>
                    <Text id="plans.items.second.advantage.item1" />
                  </li>
                  <li class="highlight">
                    <Text id="plans.items.second.advantage.item2" />
                  </li>
                  <li>
                    <Text id="plans.items.second.advantage.item3" />
                  </li>
                </ul>
                <div class="price">
                  <span class="value">€39</span>{" "}
                  <span class="period">
                    / <Text id="cart.month.full" />
                  </span>
                </div>
                <div class="term">
                  <Text id="plans.items.note" />{" "}
                  <div>
                    <Text id="plans.items.second.noteMonth" />{" "}
                    <Text id="cart.months.full" />
                  </div>
                </div>
              </div>
              <a
                onClick={() => {
                  store.setDesiredService(2);
                  route(store.prefix + "/availability");
                }}
                href="javascript:"
                class="button"
              >
                <Text id="plans.items.btn" />
              </a>
            </li>
            <li>
              <div class="inner">
                <h3>
                  <Text id="plans.items.third.title" />
                </h3>
                <IconBar
                  color="#f03a47"
                  number="1000"
                  percent={this.state.persentage[2]}
                />
                <ul>
                  <li>
                    <Text id="plans.items.third.advantage.item" />
                  </li>
                  <li>
                    <Text id="plans.items.third.advantage.item1" />
                  </li>
                  <li class="highlight">
                    <Text id="plans.items.third.advantage.item2" />
                  </li>
                  <li>
                    <Text id="plans.items.third.advantage.item3" />
                  </li>
                </ul>
                <div class="price">
                  <span class="value">€79</span>{" "}
                  <span class="period">
                    / <Text id="cart.month.full" />
                  </span>
                </div>
                <div class="term">
                  <Text id="plans.items.note" />{" "}
                  <div>
                    <Text id="plans.items.third.noteMonth" />{" "}
                    <Text id="cart.months.full" />
                  </div>
                </div>
              </div>
              <a
                onClick={() => {
                  store.setDesiredService(3);
                  route(store.prefix + "/availability");
                }}
                href="javascript:"
                class="button"
              >
                <Text id="plans.items.btn" />
              </a>
            </li>
          </ul>
        </div>
        <div class="container plans">
          <article>
            {!props.home && (
              <h2>
                <Text id="plans.footer.title" />
              </h2>
            )}
            <p>
              <Text id="plans.footer.text.item" />
              <strong>
                {" "}
                <Text id="plans.footer.text.bold" />
              </strong>
              <Text id="plans.footer.text.item2" />
              &nbsp;
              <Link href={store.prefix + "/contact?service=leased&form=true"}>
                <Text id="plans.footer.text.link" />
              </Link>
              .
            </p>
            <p>
              <Text id="plans.footer.bezPVN" />&nbsp;
              <a href="/assets/Dolphnet_liguma_kopsavilkums.pdf" target="_blank"><Text id="plans.footer.bezPVNextra" /></a>
            </p>
          </article>
        </div>
      </div>
    );
  }
}

export default Plans;



// WEBPACK FOOTER //
// ./components/plans.js